import { render, staticRenderFns } from "./addSubscr.vue?vue&type=template&id=95a241e8&scoped=true"
import script from "./addSubscr.vue?vue&type=script&lang=js"
export * from "./addSubscr.vue?vue&type=script&lang=js"
import style0 from "./addSubscr.vue?vue&type=style&index=0&id=95a241e8&prod&lang=css"
import style1 from "./addSubscr.vue?vue&type=style&index=1&id=95a241e8&prod&scoped=true&lang=css"
import style2 from "./addSubscr.vue?vue&type=style&index=2&id=95a241e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95a241e8",
  null
  
)

export default component.exports